function getExpertisesScroller() {
  if ($.mlmi.scroller.hasClass('scroller')) {
    return $.mlmi.scroller
  }
  return $('html, body')
}

$.fn.Expertises = function() {
  let self = this

  if (self.data('expertises')) {
    return self.data('expertises')
  }

  self.initialized = false;

  self.initialize_desktop = function() {
    if (self.initialized) {
      return
    }

    self.find('.tabs__panel-content').each(function() {
      let panel = $(this),
      original = $('.accordion__panel-content[data-expertise="' + panel.data('expertise') + '"]'),
      target = $('<div class="expertise"></div>'),
      section = panel.find('.page-section')
      target.append(original.find('.expertise__description').clone())
      target.append(original.find('.expertise__services').clone())
      original.find('.grid-row').each(function() {
        section.append($(this).clone())
      })
      panel.prepend(target)
      panel.append(original.find('.expertise__projects').clone())
    })

    $('.tabs--expertise .btn-down').each(function() {
      $(this).on('click', function() {
        let anchor_name = $(this).attr('href').substr(1)
        if ($('.tabs--expertise a[name="' + anchor_name + '"]').length) {
          let target = $('.tabs--expertise a[name="' + anchor_name + '"]'),
          targetTop = target.offset().top - $.mlmi.getOffset(62)
          if ($('body').hasClass('has-scrollbars')) {
            targetTop += getExpertisesScroller().scrollTop()
          }
          getExpertisesScroller().scrollTo(targetTop, 450, 5, 'easeInOutQuart')
          return false;
        }
      })
    })

    self.initialized = true
  }

  return function() {
    self.data('expertises', self)
    $.mlmi.mobile.add(function() {}, self.initialize_desktop)
    return self
  }()
}
